import Loader from "./Loader.js";
export default Loader;
